<template>
<div class="marunageContent__container">
  <slot name="title"></slot>
  <a @click.prevent="openDialog" class="ui big form clickable">
  <div class="ui warning message" v-if="form.hasErrors()">
    <ul class="list">
      <li v-if="form.hasError('area')">エリアを選択してください</li>
      <li v-if="form.hasError('people')">人数を選択してください</li>
      <li v-if="form.hasError('price')">一人あたりの予算を選択してください</li>
      <li v-if="form.hasError('event_date')">希望日を選択してください</li>
      <li v-if="form.hasError('event_time')">希望時間を選択してください</li>
      <li v-if="form.hasError('tel')">電話番号を半角数字のみ10桁または11桁で入力してください</li>
      <li v-if="form.hasError('email')">メールアドレスを正しく入力してください</li>
    </ul>
  </div>
  <div class="marunageContent__formContainer ui form large">
    <div class="marunageContent__conditions">
      <div class="marunageContent__condition">
        <div class="two fields marunageContent__formRow marunageContent__formRow--splitMobile">
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('area')}">
            <dropdown v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア(必須)'">
              <option v-for="each in consts.MARUNAGE_SHOP_AREA" :key="each.label" :value="each.value" :disabled="each.value === ''">
              {{ each.label }}
              </option>
            </dropdown>
          </div>
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('area_detail')}">
            <dropdown ref="areaDetail" v-model="form.model.area_detail" :placeholder="'エリア詳細'">
              <option value="">エリア詳細</option>
            </dropdown>
          </div>
        </div>
        <div class="two fields marunageContent__formRow marunageContent__formRow--splitMobile">
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('people')}">
            <dropdown v-model="form.model.people" :options="consts.MARUNAGE_PEOPLE" :placeholder="'人数(必須)'"></dropdown>
          </div>
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('price')}">
            <dropdown v-model="form.model.price" :options="consts.MARUNAGE_PRICE" :placeholder="'予算(必須)'"></dropdown>
          </div>
        </div>
        <div class="two fields marunageContent__formRow marunageContent__formRow--splitMobile">
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('event_date')}">
            <datepick v-model="form.model.event_date" :placeholder="'希望日(必須)'" :from="3"></datepick>
          </div>
          <div class="field marunageContent__formItem" :class="{'error': form.hasError('event_time')}">
            <dropdown v-model="form.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間(必須)'"></dropdown>
          </div>
        </div>
        <div class="caption marunageContent__caption">
          日程が確定していない場合は仮の日時をご指定いただき、希望条件欄に大体の開催時期をご記載ください
        </div>
      </div>
      <div class="marunageContent__condition">
        <div v-if="!userId" class="field marunageContent__formRow" :class="{'error': form.hasError('email')}">
          <input type="text" v-model="form.model.email" :placeholder="'ご連絡先メールアドレス(必須)'" />
        </div>
        <div v-if="!hasTel" class="field marunageContent__formRow" :class="{'error': form.hasError('tel')}">
          <input type="text" v-model="form.model.tel" :placeholder="'ご連絡先電話番号(必須)'" />
        </div>
        <div class="field marunageContent__formRow" :class="{'error': form.hasError('note')}">
          <div class="marunageContent__textareaContainer">
            <textarea rows="4" v-model="form.model.note" placeholder="希望条件があればご記入ください。"></textarea>
            <div class="marunageContent__marunagekun">
              <span class="marunageContent__marunageSpeak">20名以上の宴会専用予約の電話番号はこちら！</span>
              <img :src="imageUrl('/marunagekun.png')" class="marunageContent__marunageImage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="marunageContent__buttonContainer">
      <div class="marunageContent__submitButton">
        <app-message :msg="form.appMessage"></app-message>
        <button @click="marunage" class="ui button orange big fluid" :class="{'disabled loading': form.waiting}">お店を探してもらう</button>
      </div>
      <div class="marunageContent__tel">
        <div class="marunageContent__telHintContainer">
          <span class="marunageContent__telHintTop">お電話でのご相談はこちら</span>
          <span class="marunageContent__telHintBottom">24時間・年中無休</span>
        </div>
        <div class="marunageContent__telNoContainer">
          <i class="fas fa-phone-volume fa-3x marunageContent__telIcon" data-fa-transform="rotate-330"></i>
          <div class="marunageContent__telNoTextContainer">
            <span class="marunageContent__telNoName">宴会コンシェルジュデスク</span>
            <span class="marunageContent__telNo"><concierge-tel></concierge-tel></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="detailed-marunage-form-dialog" class="ui modal">
    <i class="close icon"></i>
    <div class="scrolling content">
      <detailed-marunage-form :form-name-prefix="formNamePrefix"></detailed-marunage-form>
    </div>
  </div>
  </a>
</div>
</template>

<script>
import DetailedMarunageForm from './detailedMarunageForm.vue';

export default {
    components: {
      DetailedMarunageForm: DetailedMarunageForm
    },
    props: {
        title: {
            required: false,
            type: String,
            default: '完全無料！カンタン60秒でスピード依頼'
        },
        formNamePrefix: {
            required: false,
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            form: this.createForm({
                area_detail: null
            }),
            hasTel: false
        };
    },
    created: function() {
        // ログイン済みの場合は下記データはログイン情報を利用するのでダミーデータを入れておく
        if (this.userId) {
            this.createForm().get('/api/member/profile', function(response) {
                this.form.model.email = response.data.user.login_id;
                this.form.model.tel = response.data.tel;
                if (this.form.model.tel) {
                    this.hasTel = true;
                }
            });
        }
    },
    methods: {
        openDialog: function() {
            $('#detailed-marunage-form-dialog').modal({autofocus: false}).modal('show');
        },
        onAreaChange: function() {
            this.form.model.area_detail = null;
            this.$refs.areaDetail.setOptions(this.areaDetailsOf(this.form.model.area));
        },
        marunage: function() {
            this.form.post('/api/marunages', function(response) {
                this.pushDataLayer({
                    'category': 'まるなげ',
                    'result': true,
                    'eventCallback': function() {
                        document.location = response.data.chat_url + '&opened=true';
                    }.bind(this)
                });
            }, function() {
                this.pushDataLayer({
                    'category': 'まるなげ',
                    'result': false
                });
            });
        }
    }
};
</script>
